const debounce = (func, delay) => {
  let inDebounce;
  return function() {
    const context = this;
    const args = arguments;
    clearTimeout(inDebounce);
    inDebounce = setTimeout(() => func.apply(context, args), delay);
  };
};

export default {
  bind(el) {
    window.addEventListener(
      'scroll',
      debounce(function() {
        if (this.scrollY >= 180) {
          el.classList.add('sticky');
        } else {
          el.classList.remove('sticky');
        }
      }, 25)
    );
  },
  undind(el) {
    window.removeEventListener('scroll');
    el.classList.remove('sticky');
  }
};
